__turbopack_context__.v({
  "actionCol": "researchTable-module-scss-module__tvRPaq__actionCol",
  "actionItem": "researchTable-module-scss-module__tvRPaq__actionItem",
  "colDate": "researchTable-module-scss-module__tvRPaq__colDate",
  "colName": "researchTable-module-scss-module__tvRPaq__colName",
  "colPublisher": "researchTable-module-scss-module__tvRPaq__colPublisher",
  "colSector": "researchTable-module-scss-module__tvRPaq__colSector",
  "colType": "researchTable-module-scss-module__tvRPaq__colType",
  "dataTable": "researchTable-module-scss-module__tvRPaq__dataTable",
  "dataTableContainer": "researchTable-module-scss-module__tvRPaq__dataTableContainer",
  "dataTableHeaderIcon": "researchTable-module-scss-module__tvRPaq__dataTableHeaderIcon",
  "dataTableOuter": "researchTable-module-scss-module__tvRPaq__dataTableOuter",
  "downloadDocumentIcon": "researchTable-module-scss-module__tvRPaq__downloadDocumentIcon",
  "draggableCol": "researchTable-module-scss-module__tvRPaq__draggableCol",
  "emptyMessage": "researchTable-module-scss-module__tvRPaq__emptyMessage",
  "expandableChildrenRow": "researchTable-module-scss-module__tvRPaq__expandableChildrenRow",
  "expandableRow": "researchTable-module-scss-module__tvRPaq__expandableRow",
  "expandedRow": "researchTable-module-scss-module__tvRPaq__expandedRow",
  "expandedTableRow": "researchTable-module-scss-module__tvRPaq__expandedTableRow",
  "highlightedRow": "researchTable-module-scss-module__tvRPaq__highlightedRow",
  "inputCol": "researchTable-module-scss-module__tvRPaq__inputCol",
  "isActionDisabled": "researchTable-module-scss-module__tvRPaq__isActionDisabled",
  "isActionItemHoveredVisible": "researchTable-module-scss-module__tvRPaq__isActionItemHoveredVisible",
  "isActionItemVisible": "researchTable-module-scss-module__tvRPaq__isActionItemVisible",
  "isAsc": "researchTable-module-scss-module__tvRPaq__isAsc",
  "isDesc": "researchTable-module-scss-module__tvRPaq__isDesc",
  "isDraggingColumn": "researchTable-module-scss-module__tvRPaq__isDraggingColumn",
  "isHoverable": "researchTable-module-scss-module__tvRPaq__isHoverable",
  "isRowBorderTop": "researchTable-module-scss-module__tvRPaq__isRowBorderTop",
  "isSecondaryTable": "researchTable-module-scss-module__tvRPaq__isSecondaryTable",
  "isSortable": "researchTable-module-scss-module__tvRPaq__isSortable",
  "isStripedEven": "researchTable-module-scss-module__tvRPaq__isStripedEven",
  "isStripedOdd": "researchTable-module-scss-module__tvRPaq__isStripedOdd",
  "isVisible": "researchTable-module-scss-module__tvRPaq__isVisible",
  "noWrap": "researchTable-module-scss-module__tvRPaq__noWrap",
  "nowrapCells": "researchTable-module-scss-module__tvRPaq__nowrapCells",
  "publishedAt": "researchTable-module-scss-module__tvRPaq__publishedAt",
  "publishedAtActions": "researchTable-module-scss-module__tvRPaq__publishedAtActions",
  "researchTable": "researchTable-module-scss-module__tvRPaq__researchTable",
  "scrollableBody": "researchTable-module-scss-module__tvRPaq__scrollableBody",
  "sectorLabel": "researchTable-module-scss-module__tvRPaq__sectorLabel",
  "sortable": "researchTable-module-scss-module__tvRPaq__sortable",
  "stickyDataTableContainer": "researchTable-module-scss-module__tvRPaq__stickyDataTableContainer",
  "stickyLeftTableContainer": "researchTable-module-scss-module__tvRPaq__stickyLeftTableContainer",
});
